var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 165,
    viewBox: "0 0 228 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M163.242 1.08789H222.148C224.69 1.08789 226.75 3.14829 226.75 5.68993V60.9144",
    stroke: "white",
    strokeWidth: 0.920408
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M163.242 164H222.148C224.69 164 226.75 161.94 226.75 159.398V104.173",
    stroke: "white",
    strokeWidth: 0.920408
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M64.7578 1.08789H5.85169C3.31005 1.08789 1.24965 3.14829 1.24965 5.68993V60.9144",
    stroke: "white",
    strokeWidth: 0.920408
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M64.7578 164H5.85169C3.31005 164 1.24965 161.94 1.24965 159.398V104.173",
    stroke: "white",
    strokeWidth: 0.920408
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.9e1cfc666a3264659d0f02298f6004c5.svg";
export { ForwardRef as ReactComponent };